(function () {

//============================================================================================================================================
// Generate a unique ID to tie a customer's clubhead/shaft/grip line items
// together in the cart as one bundle

function makeBundleId() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  return 'bundle-' + Date.now() + '-' + Math.random().toString(16).slice(2);
}
//============================================================================================================================================

  function initInstance(root) {

    //============================================================================================================================================
    // DOM References
    // Every element on the block we'll read from or write to

    const handRadios = root.querySelectorAll('input[data-hand-radio]');
    const setPills = root.querySelectorAll('[data-set-pill]');
    const countEl = root.querySelector('[data-selected-count]');
    const addBtn = root.querySelector('[data-add-to-cart]');

    const clubCatalogScript = root.querySelector('[data-club-catalog]');
    const shaftCatalogScript = root.querySelector('[data-shaft-catalog]');
    const gripCatalogScript = root.querySelector('[data-grip-catalog]');

    const gripManufacturerSelect = root.querySelector('[data-grip-manufacturer-select]');
    const gripSelect = root.querySelector('[data-grip-select]');
    const gripSizeGroup = root.querySelector('[data-grip-size-group]');
    const gripPreview = root.querySelector('[data-grip-preview]');
    const gripPreviewImage = root.querySelector('[data-grip-preview-image]');
    const defaultGripId = root.getAttribute('data-default-grip-id') || '';

    const manufacturerSelect = root.querySelector('[data-manufacturer-select]');
    const shaftSelect = root.querySelector('[data-shaft-select]');
    const flexGroup = root.querySelector('[data-flex-group]');
    const shaftPreview = root.querySelector('[data-shaft-preview]');
    const shaftPreviewImage = root.querySelector('[data-shaft-preview-image]');
    const imageUnavailableFallback = root.getAttribute('data-image-unavailable-fallback') || '';
    const defaultShaftId = root.getAttribute('data-default-shaft-id') || '';
    // Set by the "Allow shaft modification" block setting. Anything other
    // than the literal string 'false' means the customer can change the shaft.
    const canModifyShaft = root.getAttribute('data-can-modify-shaft') !== 'false';
    const shaftLockedNote = root.querySelector('[data-shaft-locked-note]');
    const lengthAdjustSlider = root.querySelector('[data-length-adjust-slider]');
    const lengthAdjustValueEl = root.querySelector('[data-length-adjust-value]');
    const lieAdjustSlider = root.querySelector('[data-lie-adjust-slider]');
    const lieAdjustValueEl = root.querySelector('[data-lie-adjust-value]');
    const loftAdjustSlider = root.querySelector('[data-loft-adjust-slider]');
    const loftAdjustValueEl = root.querySelector('[data-loft-adjust-value]');
    const shaftStepSlider = root.querySelector('[data-shaft-step-slider]');
    const shaftStepValueEl = root.querySelector('[data-shaft-step-value]');

    const customizeGroups = root.querySelectorAll('[data-customize-group]');

    const tabButtons = root.querySelectorAll('[data-tab-target]');
    const tabPanels = root.querySelectorAll('[data-tab-panel]');
    //============================================================================================================================================

    //============================================================================================================================================
    // Load Product Catalog
    // Club data is injected by Liquid as JSON in a <script> tag on the
    // page. We parse it once here for the JS to work with

    let clubCatalog = {};
    try {
      clubCatalog = clubCatalogScript ? JSON.parse(clubCatalogScript.textContent) : {};
    } catch (err) {
      console.error('putter-configurator: could not parse club catalog', err);
    }

    let shaftCatalog = [];
    try {
      const parsedShaftCatalog = shaftCatalogScript ? JSON.parse(shaftCatalogScript.textContent) : [];
      // Liquid emits a trailing null placeholder to dodge trailing-comma
      // JSON errors when filtering by tag — strip it here.
      shaftCatalog = parsedShaftCatalog.filter(Boolean);
    } catch (err) {
      console.error('putter-configurator: could not parse shaft catalog', err);
    }

    let gripCatalog = [];
    try {
      const parsedGripCatalog = gripCatalogScript ? JSON.parse(gripCatalogScript.textContent) : [];
      gripCatalog = parsedGripCatalog.filter(Boolean);
    } catch (err) {
      console.error('putter-configurator: could not parse grip catalog', err);
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Determine Active Hand and Head Style, Resolve the Selected Variant
    // Club catalog is keyed by hand ('0' = right, '1' = left, etc), each
    // holding one entry per Head Style value for that hand. The
    // combination of active hand + active head style pill resolves to
    // exactly one variant — that variant IS the clubhead line item.
    // Single-select only: at most one Head Style, at most one variant.

    function getCurrentHandIndex() {
      const selectedRadio = root.querySelector('input[data-hand-radio]:checked');
      return selectedRadio ? selectedRadio.value : '0';
    }

    function getClubsForCurrentHand() {
      return clubCatalog[getCurrentHandIndex()] || [];
    }

    function getCurrentSetValue() {
      const checkedInput = root.querySelector('input[data-set-radio]:checked');
      return checkedInput ? checkedInput.value : null;
    }

    // The single currently selected variant, or null if none.
    function getSelectedVariant() {
      const setValue = getCurrentSetValue();
      if (!setValue) return null;
      const clubsForHand = getClubsForCurrentHand();
      return clubsForHand.find(function (entry) { return entry.setValue === setValue; }) || null;
    }

    // Total club count for the selected variant — drives shaft/grip/finish
    // quantity.
    // FIX: a putter is always at least one club. If the clubset.club_id
    // metafield is empty or not a list, fall back to 1 instead of 0 so the
    // Add to Cart button doesn't stay disabled forever.
    function getTotalClubCount() {
      const variant = getSelectedVariant();
      if (!variant) return 0;
      return (Array.isArray(variant.clubIds) && variant.clubIds.length) ? variant.clubIds.length : 1;
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Let Customer Pick a Head Style
    // Clicking a pill just changes which radio is checked (native radio
    // behavior) — the actual variant resolution happens on demand via
    // getSelectedVariant() wherever it's needed.

    function applySetSelection(pill) {
      const input = pill.querySelector('[data-set-radio]');
      if (!input) return;

      setPills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
      input.checked = true;

      updateHeadsOnlyTabState();
      updateSummary();
    }

    function updateSetAvailability() {
      const clubsForHand = getClubsForCurrentHand();

      setPills.forEach(function (pill) {
        const setValue = pill.getAttribute('data-set-value');
        const entry = clubsForHand.find(function (e) { return e.setValue === setValue; });
        const available = !!(entry && entry.available);

        const radio = pill.querySelector('[data-set-radio]');
        pill.classList.toggle('is-disabled', !available);
        if (radio) radio.disabled = !available;
        if (!available) {
          pill.classList.remove('is-active');
          if (radio) radio.checked = false;
        }
      });
    }

    function selectDefaultSet() {
      const firstAvailable = Array.prototype.find.call(setPills, function (pill) {
        return !pill.classList.contains('is-disabled');
      });
      if (firstAvailable) {
        applySetSelection(firstAvailable);
      }
    }

    // Heads-only mode: true if the currently selected variant is flagged
    // heads_only.
    function isHeadsOnlyMode() {
      const variant = getSelectedVariant();
      return !!(variant && variant.headsOnly);
    }

    function updateHeadsOnlyTabState() {
      const headsOnly = isHeadsOnlyMode();

      tabButtons.forEach(function (btn) {
        const target = btn.getAttribute('data-tab-target');
        if (target === 'shaft' || target === 'grip') {
          btn.disabled = headsOnly;
          // If the customer was sitting on a tab that just got disabled,
          // bounce them back to Club rather than leaving a disabled tab active.
          if (headsOnly && btn.classList.contains('is-active')) {
            switchTab('club');
          }
        }
      });

      // The Grip tab's "Next: Review" jump is fine to disable along with
      // its tab, since heads-only never reaches the Grip tab at all. The
      // Club tab's "Next" button is different — it must always stay
      // clickable, just pointed at Review instead of Shaft when heads-only.
      root.querySelectorAll('[data-tab-jump="grip"]').forEach(function (btn) {
        btn.disabled = headsOnly;
      });

      const nextFromClubBtn = root.querySelector('[data-next-from-club-btn]');
      if (nextFromClubBtn) {
        if (headsOnly) {
          nextFromClubBtn.textContent = 'Next: Review';
          nextFromClubBtn.setAttribute('data-tab-jump', 'review');
        } else {
          nextFromClubBtn.textContent = 'Next: Shaft';
          nextFromClubBtn.setAttribute('data-tab-jump', 'shaft');
        }
      }
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Show Customer a Summary of Their Build on the Review Tab
    // Pulls together club/shaft/grip/finish selections and running totals

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function renderReview() {
      const reviewClubEl = root.querySelector('[data-review-club]');
      const reviewShaftEl = root.querySelector('[data-review-shaft]');
      const reviewGripEl = root.querySelector('[data-review-grip]');
      const reviewTotalEl = root.querySelector('[data-review-total]');

      const variant = getSelectedVariant();
      const clubCount = getTotalClubCount();
      const setValue = getCurrentSetValue();

      const finishRadio = getSelectedFinish();
      const finishName = finishRadio ? finishRadio.value : 'Standard';
      // Price in cents, read from the finish's Associated_Product variant.
      // Free finishes have no data-upcharge-price, so this is 0.
      const finishPriceCents = finishRadio ? (parseFloat(finishRadio.getAttribute('data-upcharge-price')) || 0) : 0;

      const headsOnly = isHeadsOnlyMode();
      const clubTotalCents = variant ? (variant.price || 0) : 0;

      if (reviewClubEl) {
        if (!variant) {
          reviewClubEl.textContent = 'No head style selected yet.';
        } else {
          const clubHtml =
            (setValue ? setValue + ' — ' : '') +
            clubCount + ' club(s)' + (headsOnly ? ' (Heads Only)' : '') + '<br>Finish: ' + finishName +
            (finishPriceCents > 0 ? ' (+' + formatMoney(finishPriceCents) + '/club)' : '');
          reviewClubEl.innerHTML = clubHtml;
        }
      }

      const selectedShaft = headsOnly ? null : getSelectedShaft();
      if (reviewShaftEl) {
        if (headsOnly) {
          reviewShaftEl.textContent = 'Not included — heads only.';
        } else if (!selectedShaft) {
          reviewShaftEl.textContent = 'No shaft selected yet.';
        } else {
          reviewShaftEl.innerHTML =
            selectedShaft.label + '<br>' +
            'Length: ' + selectedShaft.lengthLabel + ' · Lie: ' + selectedShaft.lieLabel + ' · Loft: ' + selectedShaft.loftLabel + '<br>' +
            'Shaft Stepping: ' + selectedShaft.stepLabel;
        }
      }

      const selectedGrip = headsOnly ? null : getSelectedGrip();
      const wrapsRadio = root.querySelector('[data-customize-group="Extra Wraps"] .option-radio:checked');
      const wrapsValue = wrapsRadio ? wrapsRadio.value : '0';
      if (reviewGripEl) {
        if (headsOnly) {
          reviewGripEl.textContent = 'Not included — heads only.';
        } else if (!selectedGrip) {
          reviewGripEl.textContent = 'No grip selected yet.';
        } else {
          reviewGripEl.innerHTML = selectedGrip.label + '<br>Extra Wraps: ' + wrapsValue;
        }
      }

      if (reviewTotalEl) {
        if (!variant || clubCount === 0 || (!headsOnly && (!selectedShaft || !selectedGrip))) {
          reviewTotalEl.textContent = 'Complete all steps to see total';
        } else {
          const finishTotalCents = finishPriceCents * clubCount;
          const shaftTotalCents = headsOnly ? 0 : selectedShaft.price * clubCount;
          const gripTotalCents = headsOnly ? 0 : selectedGrip.price * clubCount;
          const totalCents = clubTotalCents + finishTotalCents + shaftTotalCents + gripTotalCents;
          let breakdown =
            'Clubs (' + clubCount + '): ' + formatMoney(clubTotalCents) + '<br>' +
            'Finish upcharge: ' + formatMoney(finishTotalCents) + '<br>';
          if (!headsOnly) {
            breakdown +=
              'Shaft upcharge: ' + formatMoney(shaftTotalCents) + '<br>' +
              'Grip upcharge: ' + formatMoney(gripTotalCents) + '<br>';
          }
          breakdown += '<strong>Total: ' + formatMoney(totalCents) + '</strong>';
          reviewTotalEl.innerHTML = breakdown;
        }
      }
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Move Customer Between Tabs, and Reset Build When Hand Changes
    // Left-hand/right-hand catalogs are separate lists, so switching hands
    // re-validates head style availability and picks a fresh default

    function switchTab(targetTab) {
      tabButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-tab-target') === targetTab);
      });
      tabPanels.forEach(function (panel) {
        panel.classList.toggle('is-hidden', panel.getAttribute('data-tab-panel') !== targetTab);
      });
      if (targetTab === 'review') {
        renderReview();
      }
    }

    function switchHand() {
      updateSetAvailability();
      selectDefaultSet();
      updateHeadsOnlyTabState();
      updateSummary();
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Get List of Shaft Manufacturers and Present Them to the Customer
    // OEM -> Filter OEM and Show Available Models -> Show Flex Variants as
    // Single Selection Option

    function populateManufacturers() {
      if (!manufacturerSelect) return;
      const seen = {};
      manufacturerSelect.innerHTML = '';
      shaftCatalog.forEach(function (shaftProduct) {
        const name = shaftProduct.manufacturer;
        if (!name || seen[name]) return;
        seen[name] = true;
        const opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        manufacturerSelect.appendChild(opt);
      });

      // If a Default Shaft metafield is set, jump the dropdown to that
      // product's manufacturer instead of whatever's naturally first.
      if (defaultShaftId) {
        const defaultShaftProduct = shaftCatalog.find(function (p) { return String(p.id) === String(defaultShaftId); });
        if (defaultShaftProduct) {
          manufacturerSelect.value = defaultShaftProduct.manufacturer;
        }
      }

      populateShafts();
    }

    function populateShafts() {
      if (!shaftSelect || !manufacturerSelect) return;
      const manufacturerName = manufacturerSelect.value;
      shaftSelect.innerHTML = '';
      shaftCatalog
        .filter(function (shaftProduct) { return shaftProduct.manufacturer === manufacturerName; })
        .forEach(function (shaftProduct) {
          const opt = document.createElement('option');
          opt.value = shaftProduct.id;
          opt.textContent = shaftProduct.title;
          shaftSelect.appendChild(opt);
        });

      // Default Shaft wins the model dropdown too, if it's within the
      // currently selected manufacturer.
      if (defaultShaftId) {
        const hasDefault = Array.prototype.some.call(shaftSelect.options, function (opt) {
          return opt.value === String(defaultShaftId);
        });
        if (hasDefault) {
          shaftSelect.value = String(defaultShaftId);
        }
      }

      populateFlex();
      updateShaftPreview();
    }

    // Preview image is per-product (not per-flex), so this only needs to
    // run when the shaft product selection changes, not on every flex click.
    // The dropdown option itself never depends on whether an image exists —
    // missing image just falls back to the "Image Unavailable" graphic.
    function updateShaftPreview() {
      if (!shaftPreview || !shaftPreviewImage) return;
      const shaftProduct = getSelectedShaftProduct();
      const imageSrc = (shaftProduct && shaftProduct.image) ? shaftProduct.image : imageUnavailableFallback;
      shaftPreviewImage.src = imageSrc;
      shaftPreviewImage.alt = shaftProduct ? shaftProduct.title : 'Image unavailable';
      shaftPreview.classList.remove('is-hidden');
    }

    function getSelectedShaftProduct() {
      if (!shaftSelect) return null;
      return shaftCatalog.find(function (p) { return String(p.id) === String(shaftSelect.value); }) || null;
    }

    function populateFlex() {
      if (!flexGroup) return;
      const shaftProduct = getSelectedShaftProduct();
      flexGroup.innerHTML = '';
      if (!shaftProduct) return;

      shaftProduct.variants.forEach(function (variant, index) {
        const label = document.createElement('label');
        label.className = 'option-pill' + (variant.available ? '' : ' is-disabled');

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'shaft_flex_' + root.getAttribute('data-block-id');
        input.className = 'option-radio';
        input.setAttribute('data-flex-radio', '');
        input.value = variant.id;
        input.setAttribute('data-price', variant.price);
        input.setAttribute('data-flex-name', variant.flex);
        if (!variant.available) input.disabled = true;
        if (index === 0) input.checked = true;

        const content = document.createElement('div');
        content.className = 'pill-content';
        const nameSpan = document.createElement('span');
        nameSpan.className = 'pill-name';
        nameSpan.textContent = variant.flex;
        content.appendChild(nameSpan);

        const flexPriceCents = variant.price || 0;
        if (flexPriceCents > 0) {
          const badge = document.createElement('span');
          badge.className = 'upcharge-badge';
          badge.textContent = '+$' + (flexPriceCents / 100).toFixed(2) + ' per club';
          content.appendChild(badge);
        }

        label.appendChild(input);
        label.appendChild(content);
        flexGroup.appendChild(label);

        input.addEventListener('change', function () {
          flexGroup.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('is-active'); });
          label.classList.add('is-active');
        });
      });

      const firstPill = flexGroup.querySelector('.option-pill');
      if (firstPill) firstPill.classList.add('is-active');
    }

    function getSelectedShaft() {
      const shaftProduct = getSelectedShaftProduct();
      const flexRadio = flexGroup ? flexGroup.querySelector('[data-flex-radio]:checked') : null;
      if (!shaftProduct || !flexRadio) return null;

      return {
        variantId: flexRadio.value,
        label: shaftProduct.title + ' — ' + flexRadio.getAttribute('data-flex-name'),
        price: parseFloat(flexRadio.getAttribute('data-price')) || 0,
        lengthLabel: lengthAdjustSlider ? formatAdjustValue(lengthAdjustSlider.value, '"', 'Short', 'Long') : '',
        lieLabel: lieAdjustSlider ? formatAdjustValue(lieAdjustSlider.value, '°', 'Flat', 'Upright') : '',
        loftLabel: loftAdjustSlider ? formatAdjustValue(loftAdjustSlider.value, '°', 'Weak', 'Strong') : '',
        stepLabel: shaftStepSlider ? formatShaftStepValue(shaftStepSlider.value) : ''
      };
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Lock the Shaft Selection When Modification Is Disabled
    // When the block setting is off, the Default Shaft metafield product is
    // selected and the manufacturer / model / flex controls are disabled.
    // Length, lie, loft and stepping stay adjustable. If no valid default
    // shaft exists in the catalog, we do NOT lock (otherwise the customer
    // would be stuck with an arbitrary first shaft) and log a warning.

    function applyShaftLock() {
      if (canModifyShaft) return;

      const hasDefault = !!defaultShaftId && shaftCatalog.some(function (p) {
        return String(p.id) === String(defaultShaftId);
      });
      if (!hasDefault) {
        console.warn('putter-configurator: shaft modification is disabled but no valid Default Shaft is set on this product, leaving shaft unlocked');
        return;
      }

      if (manufacturerSelect) manufacturerSelect.disabled = true;
      if (shaftSelect) shaftSelect.disabled = true;
      if (flexGroup) {
        flexGroup.querySelectorAll('input[data-flex-radio]').forEach(function (input) {
          input.disabled = true;
        });
        flexGroup.querySelectorAll('.option-pill').forEach(function (pill) {
          pill.classList.add('is-locked');
        });
      }
      if (shaftLockedNote) shaftLockedNote.classList.remove('is-hidden');
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Let Customer Fine-Tune Length / Lie / Loft
    // Sliders store raw values on the element itself — these just format
    // that raw value into a readable label like "+0.5in (Long)"

    function formatAdjustValue(value, unit, negWord, posWord) {
      const num = parseFloat(value);
      if (num === 0) return 'Standard';
      const sign = num > 0 ? '+' : '';
      const word = num > 0 ? posWord : negWord;
      return sign + num + unit + ' (' + word + ')';
    }

    function updateLengthAdjustLabel() {
      if (!lengthAdjustSlider || !lengthAdjustValueEl) return;
      lengthAdjustValueEl.textContent = formatAdjustValue(lengthAdjustSlider.value, '"', 'Short', 'Long');
    }

    function updateLieAdjustLabel() {
      if (!lieAdjustSlider || !lieAdjustValueEl) return;
      lieAdjustValueEl.textContent = formatAdjustValue(lieAdjustSlider.value, '°', 'Flat', 'Upright');
    }

    function updateLoftAdjustLabel() {
      if (!loftAdjustSlider || !loftAdjustValueEl) return;
      loftAdjustValueEl.textContent = formatAdjustValue(loftAdjustSlider.value, '°', 'Weak', 'Strong');
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Let Customer Set Shaft Stepping
    // Negative = Soft Step, positive = Hard Step, 0 = Straight In.
    // "Once"/"Twice" since the range is constrained to -2..2.

    function formatShaftStepValue(value) {
      const num = parseInt(value, 10);
      if (num === 0) return 'Straight In';
      const direction = num > 0 ? 'Hard Step' : 'Soft Step';
      const count = Math.abs(num) === 2 ? 'Twice' : 'Once';
      return direction + ' ' + count;
    }

    function updateShaftStepLabel() {
      if (!shaftStepSlider || !shaftStepValueEl) return;
      shaftStepValueEl.textContent = formatShaftStepValue(shaftStepSlider.value);
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Get List of Grip Manufacturers and Present Them to the Customer
    // Same cascading pattern as shafts: OEM -> Grip Model -> Size

    function populateGripManufacturers() {
      if (!gripManufacturerSelect) return;
      const seen = {};
      gripManufacturerSelect.innerHTML = '';
      gripCatalog.forEach(function (gripProduct) {
        const name = gripProduct.manufacturer;
        if (!name || seen[name]) return;
        seen[name] = true;
        const opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        gripManufacturerSelect.appendChild(opt);
      });

      // If a Default Grip metafield is set, jump the dropdown to that
      // product's manufacturer instead of whatever's naturally first.
      if (defaultGripId) {
        const defaultGripProduct = gripCatalog.find(function (p) { return String(p.id) === String(defaultGripId); });
        if (defaultGripProduct) {
          gripManufacturerSelect.value = defaultGripProduct.manufacturer;
        }
      }

      populateGrips();
    }

    function populateGrips() {
      if (!gripSelect || !gripManufacturerSelect) return;
      const manufacturerName = gripManufacturerSelect.value;
      gripSelect.innerHTML = '';
      gripCatalog
        .filter(function (gripProduct) { return gripProduct.manufacturer === manufacturerName; })
        .forEach(function (gripProduct) {
          const opt = document.createElement('option');
          opt.value = gripProduct.id;
          opt.textContent = gripProduct.title;
          gripSelect.appendChild(opt);
        });

      // Default Grip wins the model dropdown too, if it's within the
      // currently selected manufacturer.
      if (defaultGripId) {
        const hasDefault = Array.prototype.some.call(gripSelect.options, function (opt) {
          return opt.value === String(defaultGripId);
        });
        if (hasDefault) {
          gripSelect.value = String(defaultGripId);
        }
      }

      populateGripSizes();
      updateGripPreview();
    }

    // Preview image is per-product (not per-size), so this only needs to
    // run when the grip product selection changes, not on every size click.
    // The dropdown option itself never depends on whether an image exists —
    // missing image just falls back to the "Image Unavailable" graphic.
    function updateGripPreview() {
      if (!gripPreview || !gripPreviewImage) return;
      const gripProduct = getSelectedGripProduct();
      const imageSrc = (gripProduct && gripProduct.image) ? gripProduct.image : imageUnavailableFallback;
      gripPreviewImage.src = imageSrc;
      gripPreviewImage.alt = gripProduct ? gripProduct.title : 'Image unavailable';
      gripPreview.classList.remove('is-hidden');
    }

    function getSelectedGripProduct() {
      if (!gripSelect) return null;
      return gripCatalog.find(function (p) { return String(p.id) === String(gripSelect.value); }) || null;
    }

    function populateGripSizes() {
      if (!gripSizeGroup) return;
      const gripProduct = getSelectedGripProduct();
      gripSizeGroup.innerHTML = '';
      if (!gripProduct) return;

      gripProduct.variants.forEach(function (variant, index) {
        const label = document.createElement('label');
        label.className = 'option-pill' + (variant.available ? '' : ' is-disabled');

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'grip_size_' + root.getAttribute('data-block-id');
        input.className = 'option-radio';
        input.setAttribute('data-grip-size-radio', '');
        input.value = variant.id;
        input.setAttribute('data-price', variant.price);
        input.setAttribute('data-size-name', variant.size);
        if (!variant.available) input.disabled = true;
        if (index === 0) input.checked = true;

        const content = document.createElement('div');
        content.className = 'pill-content';
        const nameSpan = document.createElement('span');
        nameSpan.className = 'pill-name';
        nameSpan.textContent = variant.size;
        content.appendChild(nameSpan);

        const sizePriceCents = variant.price || 0;
        if (sizePriceCents > 0) {
          const badge = document.createElement('span');
          badge.className = 'upcharge-badge';
          badge.textContent = '+$' + (sizePriceCents / 100).toFixed(2) + ' per club';
          content.appendChild(badge);
        }

        label.appendChild(input);
        label.appendChild(content);
        gripSizeGroup.appendChild(label);

        input.addEventListener('change', function () {
          gripSizeGroup.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('is-active'); });
          label.classList.add('is-active');
        });
      });

      const firstPill = gripSizeGroup.querySelector('.option-pill');
      if (firstPill) firstPill.classList.add('is-active');
    }

    function getSelectedGrip() {
      const gripProduct = getSelectedGripProduct();
      const sizeRadio = gripSizeGroup ? gripSizeGroup.querySelector('[data-grip-size-radio]:checked') : null;
      if (!gripProduct || !sizeRadio) return null;

      return {
        variantId: sizeRadio.value,
        label: gripProduct.title + ' — ' + sizeRadio.getAttribute('data-size-name'),
        price: parseFloat(sizeRadio.getAttribute('data-price')) || 0
      };
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Read Whatever Customization Options the Customer Has Chosen

    function getCustomizationProperties() {
      const properties = {};
      customizeGroups.forEach(function (group) {
        const label = group.getAttribute('data-customize-group');
        const checked = group.querySelector('.option-radio:checked');
        if (!checked) return;
        const displayValue = checked.getAttribute('data-property-label') || checked.value;
        properties[label] = displayValue;
      });
      return properties;
    }

    function getSelectedFinish() {
      return root.querySelector('[data-customize-group="Finish"] .option-radio:checked');
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Keep the Selected Club Count and Add to Cart Button in Sync
    // (Shaft/grip completeness checks will be added once those tabs are
    // built — for now this only gates on a valid variant being selected.)

    function updateSummary() {
      const variant = getSelectedVariant();
      const clubCount = getTotalClubCount();
      if (countEl) countEl.textContent = clubCount;

      if (!addBtn) return;

      if (!variant || clubCount === 0) {
        addBtn.disabled = true;
        return;
      }

      const headsOnly = isHeadsOnlyMode();
      if (!headsOnly) {
        const selectedShaft = getSelectedShaft();
        const selectedGrip = getSelectedGrip();
        if (!selectedShaft || !selectedGrip) {
          addBtn.disabled = true;
          return;
        }
      }

      addBtn.disabled = false;
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Refresh the Cart Drawer After a Successful Add
    // FIX: the old code assumed <cart-drawer-component> contained an
    // element with [data-section-id]. If it doesn't, querySelector returns
    // null and .getAttribute throws AFTER the items were already added,
    // leaving the customer staring at an unchanged page. This version
    // tries several ways to find the section id, and if anything at all
    // goes wrong it falls back to sending the customer to /cart, so a
    // successful add is never invisible.

    function getDrawerSectionId(drawer) {
      if (!drawer) return null;

      const inner = drawer.querySelector('[data-section-id]');
      if (inner) return inner.getAttribute('data-section-id');

      const outer = drawer.closest('[data-section-id]');
      if (outer) return outer.getAttribute('data-section-id');

      const wrapper = drawer.closest('.shopify-section');
      if (wrapper && wrapper.id) return wrapper.id.replace(/^shopify-section-/, '');

      return null;
    }

    function refreshCartUI() {
      const drawer = document.querySelector('cart-drawer-component');
      const sectionId = getDrawerSectionId(drawer);

      if (!drawer || !sectionId) {
        window.location.href = '/cart';
        return Promise.resolve();
      }

      return fetch('/?sections=' + encodeURIComponent(sectionId))
        .then(function (res) {
          if (!res.ok) throw new Error('Section fetch failed: ' + res.status);
          return res.json();
        })
        .then(function (sections) {
          const html = sections[sectionId];
          if (!html) throw new Error('Section HTML missing for ' + sectionId);

          const newDrawer = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('cart-drawer-component');
          if (!newDrawer) throw new Error('Updated cart drawer not found in section HTML');

          drawer.innerHTML = newDrawer.innerHTML;

          const dialog = drawer.querySelector('dialog');
          if (dialog && typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            throw new Error('Cart drawer dialog not found');
          }
        })
        .catch(function (err) {
          console.error('putter-configurator: drawer refresh failed, sending to /cart', err);
          window.location.href = '/cart';
        });
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Send the Customer's Build to the Cart
    // ONE clubhead line item (the selected variant, qty 1) carrying all
    // config as line item properties, plus N shaft lines and N grip lines
    // where N = club count on that variant (skipped entirely for
    // heads-only).
    // Head Finish: the finish NAME always travels as the "Head Finish"
    // property on the clubhead (the associated products are generic and
    // don't carry the name). If the selected finish has an
    // Associated_Product, that product's variant is also added as its own
    // line, quantity = club count. Free finishes (no Associated_Product)
    // add nothing to the cart.

    function submitBundleToCart() {
      const variant = getSelectedVariant();
      const clubCount = getTotalClubCount();
      if (!variant || clubCount === 0) return;

      const headsOnly = isHeadsOnlyMode();
      const selectedShaft = headsOnly ? null : getSelectedShaft();
      const selectedGrip = headsOnly ? null : getSelectedGrip();
      const finishRadio = getSelectedFinish();
      const finishName = finishRadio ? finishRadio.value : 'Standard';

      const wrapsRadio = root.querySelector('[data-customize-group="Extra Wraps"] .option-radio:checked');
      const wrapsValue = wrapsRadio ? wrapsRadio.value : '0';

      if (!headsOnly && (!selectedShaft || !selectedGrip)) {
        console.error('putter-configurator: missing shaft or grip selection');
        return;
      }

      const bundleId = makeBundleId();
      const items = [];

      const sharedProperties = {
        'Head Finish': finishName,
        '_bundle_id': bundleId
      };

      const genericProperties = getCustomizationProperties();
      if (genericProperties['Player Type']) {
        sharedProperties['Player Type'] = genericProperties['Player Type'];
      }

      if (!headsOnly) {
        sharedProperties['Club Length'] = selectedShaft.lengthLabel;
        sharedProperties['Club Lie'] = selectedShaft.lieLabel;
        sharedProperties['Club Loft'] = selectedShaft.loftLabel;
        sharedProperties['Shaft Stepping'] = selectedShaft.stepLabel;
      }
      if (wrapsValue !== '0' && !headsOnly) {
        sharedProperties['Wraps of Tape'] = wrapsValue;
      }

      // One clubhead line item for the selected variant, qty 1.
      items.push({
        id: variant.variantId,
        quantity: 1,
        properties: Object.assign({}, sharedProperties)
      });

      // Finish Upcharge — one combined line, quantity = club count.
      // Applies regardless of heads-only status. Free finishes have no
      // data-upcharge-variant-id (empty Associated_Product), so nothing
      // is added for them.
      const finishVariantId = finishRadio ? finishRadio.getAttribute('data-upcharge-variant-id') : '';
      if (finishVariantId) {
        items.push({
          id: finishVariantId,
          quantity: clubCount,
          properties: { '_bundle_id': bundleId }
        });
      }

      // Shaft/grip — one combined line each, quantity = club count.
      if (!headsOnly) {
        items.push({
          id: selectedShaft.variantId,
          quantity: clubCount,
          properties: { '_bundle_id': bundleId }
        });

        items.push({
          id: selectedGrip.variantId,
          quantity: clubCount,
          properties: { '_bundle_id': bundleId }
        });
      }

      // Submit all line items to the cart in one request
      if (addBtn) addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          // Surface Shopify's real error message (e.g. a 422 naming the
          // unavailable variant) instead of just the status code.
          return res.json().then(function (body) {
            if (!res.ok) {
              throw new Error(body.description || body.message || ('Cart add failed: ' + res.status));
            }
            return body;
          });
        })
        .then(function () {
          return refreshCartUI();
        })
        .then(function () {
          updateSummary();
        })
        .catch(function (err) {
          console.error('putter-configurator: cart add failed', err);
          alert('Sorry, we could not add your build to the cart: ' + err.message);
          updateSummary();
        });
    }
    //============================================================================================================================================

    //============================================================================================================================================
    // Wire Up All Event Listeners
    // Bound once during init, after every handler above has been defined

    handRadios.forEach(function (radio) { radio.addEventListener('change', switchHand); });
    setPills.forEach(function (pill) {
      pill.addEventListener('click', function (event) {
        if (pill.classList.contains('is-disabled')) {
          event.preventDefault();
          return;
        }
        applySetSelection(pill);
      });
    });
    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        switchTab(btn.getAttribute('data-tab-target'));
      });
    });
    root.querySelectorAll('[data-tab-jump]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchTab(btn.getAttribute('data-tab-jump'));
      });
    });
    root.querySelectorAll('.option-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        const group = this.closest('[data-customize-group]');
        if (group) {
          group.querySelectorAll('.option-pill').forEach(function (pill) { pill.classList.remove('is-active'); });
        }
        const pill = this.closest('.option-pill');
        if (pill) pill.classList.add('is-active');
        updateSummary();
      });
    });
    if (addBtn) addBtn.addEventListener('click', submitBundleToCart);
    if (manufacturerSelect) manufacturerSelect.addEventListener('change', populateShafts);
    if (shaftSelect) shaftSelect.addEventListener('change', function () {
      populateFlex();
      updateShaftPreview();
      updateSummary();
    });
    if (lengthAdjustSlider) lengthAdjustSlider.addEventListener('input', updateLengthAdjustLabel);
    if (lieAdjustSlider) lieAdjustSlider.addEventListener('input', updateLieAdjustLabel);
    if (loftAdjustSlider) loftAdjustSlider.addEventListener('input', updateLoftAdjustLabel);
    if (shaftStepSlider) shaftStepSlider.addEventListener('input', updateShaftStepLabel);
    if (gripManufacturerSelect) gripManufacturerSelect.addEventListener('change', populateGrips);
    if (gripSelect) gripSelect.addEventListener('change', function () {
      populateGripSizes();
      updateGripPreview();
      updateSummary();
    });
    //============================================================================================================================================

    //============================================================================================================================================
    // Render Initial State When the Block Loads

    switchHand();
    populateManufacturers();
    applyShaftLock();
    updateLengthAdjustLabel();
    updateLieAdjustLabel();
    updateLoftAdjustLabel();
    updateShaftStepLabel();
    populateGripManufacturers();
    updateSummary();
    //============================================================================================================================================
  }

//============================================================================================================================================
// Boot Every Configurator Block on the Page

function initAll() {
  document.querySelectorAll('.club-configurator').forEach(initInstance);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
//============================================================================================================================================
})();